import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import VerifyEmailRequiredPage from "./pages/VerifyEmailRequiredPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ChatPage from "./pages/ChatPage";
import UstadhPage from "./pages/UstadhPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import SubscriptionSuccessPage from "./pages/SubscriptionSuccessPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import BlogListPage from "./pages/BlogListPage";
import BlogPostPage from "./pages/BlogPostPage";

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/verify-email" element={<VerifyEmailPage />} />
                        <Route path="/verify-email-required" element={<VerifyEmailRequiredPage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/blogs" element={<BlogListPage />} />
                        <Route path="/blogs/:slug" element={<BlogPostPage />} />
                        
                        {/* Protected Routes */}
                        <Route 
                            path="/chat" 
                            element={
                                <ProtectedRoute>
                                    <ChatPage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/ustadh" 
                            element={
                                <ProtectedRoute requirePremium>
                                    <UstadhPage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/subscription" 
                            element={
                                <ProtectedRoute>
                                    <SubscriptionPage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/subscription/success" 
                            element={
                                <ProtectedRoute>
                                    <SubscriptionSuccessPage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/settings" 
                            element={
                                <ProtectedRoute>
                                    <SettingsPage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/admin" 
                            element={
                                <ProtectedRoute requireAdmin>
                                    <AdminPage />
                                </ProtectedRoute>
                            } 
                        />
                    </Routes>
                </BrowserRouter>
                <Toaster 
                    position="top-right" 
                    richColors 
                    closeButton
                    toastOptions={{
                        className: 'font-body'
                    }}
                />
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
